export default "__VITE_ASSET__B_kw_7aP__"